import styled from 'styled-components';

export const iframe= styled.iframe`
   &.hide{
        width: 0;
        height: 0;
   }
`;
